import React from 'react';
import PropTypes from 'prop-types';

const CurrentStatus = ({
  title,
  description,
  isClosed = false,
  isAppeal = true,
}) => (
  <div className="current-status">
    <h2>Current status</h2>
    {isClosed && (
      <va-alert status="info" slim>
        <p className="vads-u-margin-y--0">
          This {isAppeal ? 'appeal' : 'review'} is closed.
        </p>
      </va-alert>
    )}
    <div className="current-status-content">
      <h3>{title}</h3>
      <div
        data-dd-privacy="mask"
        data-dd-action-name="current status description"
      >
        {description}
      </div>
    </div>
  </div>
);

CurrentStatus.propTypes = {
  description: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  isAppeal: PropTypes.bool,
  isClosed: PropTypes.bool,
};

export default CurrentStatus;
